import { useSuspenseQuery } from '@tanstack/react-query';
import { getAgencySettingsOptions, editTechnicalAgencySettingsOptions } from '@generated';
import Yup from '~/util/yup';
import { FileText } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibraryForm } from '../shared/LibraryForm';
import { CheckboxFormField } from '~/shared/forms/controls/fields/CheckboxFormField';

export const TechnicalAgencySettingsSection = {
	settingsView: 'technical',
	title: 'Technical Settings',
	description: 'Configure technical settings',
	TitleIcon: FileText
} satisfies SettingsSectionItem;

const validationSchema = Yup.object().shape({
	chatEnabled: Yup.boolean().label('Chat Enabled').nullable()
});

export function TechnicalAgencySettings() {
	const { data: settings } = useSuspenseQuery(getAgencySettingsOptions());

	return (
		<LibraryForm
			initialValues={{
				chatEnabled: settings.chatEnabled
			}}
			saveMutation={{
				...editTechnicalAgencySettingsOptions,
				invalidateQueryKeys: [getAgencySettingsOptions().queryKey]
			}}
			validationSchema={validationSchema}
			{...TechnicalAgencySettingsSection}
		>
			<CheckboxFormField name="chatEnabled" description="Toggle to enable or disable the chat feature for users" />
		</LibraryForm>
	);
}
